<template>
    <div class="flex" v-tooltip="methodName.name">
        <div class="col flex items-center justify-items-center">
            <font-awesome-icon :icon="methodName.icon" />
        </div>
        <span class="col mx-2 rounded text-sm font-medium" v-if="!hideName">
            {{ methodName.name }}
        </span>
    </div>
</template>

<script>
export default {
    props: ["method", "hasAmountCard2", "hideName"],

    computed: {
        methodName() {
            switch (this.method) {
                case "credit_card":
                    if (this.hasAmountCard2) {
                        return {
                            icon: "fa-solid fa-money-bills",
                            name: "Dois Cartões",
                        };
                    } else {
                        return {
                            icon: "fa-solid fa-credit-card",
                            name: "Cartão de Crédito",
                        };
                    }
                case "google_pay":
                    return {
                        icon: "fa-brands fa-google-pay",
                        name: "Google Pay",
                    };
                case "apple_pay":
                    return {
                        icon: "fa-brands fa-apple-pay",
                        name: "Apple Pay",
                    };
                case "bank_slip":
                    return { icon: "fa-solid fa-barcode", name: "Boleto" };
                case "pix":
                    return { icon: "fa-brands fa-pix", name: "PIX" };
                case "pix_recurring":
                    return { icon: "fa-brands fa-pix", name: "Pix Automático" };
                default:
                    return {
                        icon: "fa-solid fa-money-bill-alt",
                        name: this.method ?? "--",
                    };
            }
        },
    },
};
</script>
